import React, { useEffect } from "react";
import module from "./Unsubscribe.module.css";
import { Divider } from "@mui/material";
import { API, Auth } from "aws-amplify";
import MostBottomButton from "../components/atomic/molecular/MostBottomButton";
import { useNavigate } from "react-router-dom";
import { listRewards } from "../graphql/queries";

const Unsubscribe = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(true);
  const [history, setHistory] = React.useState({
    transferred: {
      num: 0,
      money: 0,
    },
    notTransferred: {
      num: 0,
      money: 0,
    },
  });

  const handleClick = async () => {
    try {
      await Auth.deleteUser();
      navigate("/unsubscribe/complete");
    } catch (e) {
      console.log(e);
    }
  };

  const fetchHistory = async () => {
    try {
      setIsLoading(true);
      const userData = await Auth.currentAuthenticatedUser();
      const result = await API.graphql({
        query: listRewards,
        authMode: "AMAZON_COGNITO_USER_POOLS",
        variables: {
          filter: {
            user_id: {
              eq: userData.attributes.sub,
            },
          },
        },
      });
      const rewards = result.data.listRewards.items;
      if (rewards === 0) {
        setIsLoading(false);
        return null;
      }
      let transferredMoney = 0;
      let notTransferredMoney = 0;
      let transferredNum = 0;
      let notTransferredNum = 0;
      rewards.map((item) => {
        if (item.transfer_id) {
          transferredMoney += item.amount;
          transferredNum += 1;
        } else {
          notTransferredMoney += item.amount;
          notTransferredNum += 1;
        }
      });
      setHistory({
        transferred: {
          num: transferredNum,
          money: transferredMoney,
        },
        notTransferred: {
          num: notTransferredNum,
          money: notTransferredMoney,
        },
      });
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const Card = ({ title, contents }) => {
    return (
      <div className={module.card}>
        <div className={module.cardTitle}>
          <span>{title}</span>
        </div>
        <div className={module.divider} />
        <div className={module.cardContents}>
          {contents.map((content) => (
            <div className={module.cardContent}>
              <div>
                <span className={module.label}>{content.label}</span>
              </div>
              <div>
                <span className={module.cardValue}>
                  {content.value.toLocaleString()}
                </span>
                <span className={module.unit}>{content.unit}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={module.container}>
      <div>
        <h1 className={module.title}>退会手続き</h1>
      </div>
      <Divider />
      <div className={module.contents}>
        <div className={module.sub}>
          <p>ナッシュ紹介サービスを</p>
          <p>ご利用いただきありがとうございました。</p>
        </div>
        <div className={module.rewardLabel}>
          <p>お客様のご実績は以下の通りでございます。</p>
        </div>
        <div>
          <Card
            title={"累計実績"}
            contents={[
              { label: "紹介者数", value: history.transferred.num, unit: "人" },
              {
                label: "報酬額",
                value: history.transferred.money.toLocaleString(),
                unit: "円",
              },
            ]}
          />
          <Card
            title={"振込未申請"}
            contents={[
              { label: "紹介者数", value: history.transferred.num, unit: "人" },
              {
                label: "報酬額",
                value: history.transferred.money.toLocaleString(),
                unit: "円",
              },
            ]}
          />
        </div>
      </div>
      <MostBottomButton label={"退会する"} handleClick={handleClick} isBottom />
    </div>
  );
};

export default Unsubscribe;
